// @flow

import * as React from 'react';

type Props = {
  width?: string,
  height?: string,
  color?: string,
};

export const Chat = ({ width, height, color }: Props) => (
  <svg
    viewBox="0 0 20 20"
    width={width || '100%'}
    height={height || '100%'}
    style={{ fill: color || 'currentColor' }}
  >
    <path d="M4.28 14h9.12V6H1v10.953L4.28 14zm-4.264.087C.006 14.03 0 13.97 0 13.907V6.006C0 5.45.443 5 1.004 5H6V1.005C6 .452 6.45 0 7.004 0h12.272c.56 0 1.004.45 1.004 1.005v7.903c0 .06-.005.12-.016.18.01.058.016.118.016.18v3.768c0 .554-.34.716-.758.355L15.48 9.914h-1.2v3.995c0 .555-.443 1.005-1.004 1.005H4.8L.758 18.39c-.42.362-.758.2-.758-.354v-3.768c0-.062.005-.122.016-.18z" />
  </svg>
);
